import { FinancialsKpisActionTypes } from './constants';

type FinancialsKpisAction = { type: string, payload: {} | string };

export const financialsKpisApiResponseSuccess = (actionType: string, data: any): FinancialsKpisAction => ({
    type: FinancialsKpisActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const financialsKpisApiResponseError = (actionType: string, error: string): FinancialsKpisAction => ({
    type: FinancialsKpisActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const financialsKpisGetCharges = (query: string): FinancialsKpisAction => ({
    type: FinancialsKpisActionTypes.GET_CHARGES,
    payload: { query },
});

export const financialsKpisGetAdjustments = (query: string): FinancialsKpisAction => ({
    type: FinancialsKpisActionTypes.GET_ADJUSTMENTS,
    payload: { query },
});

export const financialsKpisGetAdjustmentsReport = (query: string): FinancialsKpisAction => ({
    type: FinancialsKpisActionTypes.GET_ADJUSTMENTS_REPORT,
    payload: { query },
});

export const financialsKpisGetCustomAdjustments = (query: string): FinancialsKpisAction => ({
    type: FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS,
    payload: { query },
});

export const financialsKpisGetCustomAdjustmentsReport = (query: string): FinancialsKpisAction => ({
    type: FinancialsKpisActionTypes.GET_CUSTOM_ADJUSTMENTS_REPORT,
    payload: { query },
});

export const financialsKpisGetMargins = (query: string): FinancialsKpisAction => ({
    type: FinancialsKpisActionTypes.GET_MARGINS,
    payload: { query },
});

export const financialsKpisGetMarginsReport = (query: string): FinancialsKpisAction => ({
    type: FinancialsKpisActionTypes.GET_MARGINS_REPORT,
    payload: { query },
});

export const financialsKpisGetVerifiedMargins = (query: string): FinancialsKpisAction => ({
    type: FinancialsKpisActionTypes.GET_VERIFIED_MARGINS,
    payload: { query },
});

export const financialsKpisGetVerifiedMarginsReport = (query: string): FinancialsKpisAction => ({
    type: FinancialsKpisActionTypes.GET_VERIFIED_MARGINS_REPORT,
    payload: { query },
});

export const financialsKpisResetState = (): FinancialsKpisAction => ({
    type: FinancialsKpisActionTypes.RESET_STATE,
});